/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// This will hide the animation once the content of the page is loaded.
$(window).on('load', function(){
	$("#loading").fadeOut(300);
});